import { alertAnatomy as n } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as l } from "@chakra-ui/react";
import { iconSizes as e } from "../../foundations/icons.mjs";
import i from "../dataDisplay/closeButton.mjs";
const { defineMultiStyleConfig: s, definePartsStyle: o } = l([
  ...n.keys,
  "close"
]), c = o((t) => ({
  container: {
    alignItems: "start",
    py: { base: 2, md: 3 }
  },
  title: {
    textStyle: "bodyBold"
  },
  description: {
    textStyle: "body",
    display: "inline-block"
  },
  icon: {
    flexShrink: 0,
    marginEnd: { base: 2, md: 3 },
    marginTop: { base: "2px", md: 0 },
    w: { base: e.xl, md: e["2xl"] },
    h: { base: e.xl, md: e["2xl"] }
  },
  close: {
    ...i.baseStyle,
    alignSelf: "flex-start",
    position: "absolute",
    right: { base: 4, md: 6 },
    top: { base: 2, md: 3 }
  }
})), r = o((t) => {
  const { colorScheme: a } = t;
  return {
    container: {
      borderStartWidth: "4px",
      borderStartColor: `${a}.500`,
      bg: `${a}.50`,
      borderRadius: "lg",
      paddingLeft: { base: 3, md: 5 }
    }
  };
}), d = o({
  container: {
    bg: "gray.50",
    paddingLeft: { base: 4, md: 6 }
  }
}), m = o((t) => ({
  container: {
    ...r(t).container,
    boxShadow: "xl"
  },
  icon: {
    marginEnd: 3
  },
  close: {
    right: 1,
    top: 1
  }
})), S = s({
  baseStyle: c,
  variants: {
    "left-accent": r,
    toast: m,
    global: d
  },
  defaultProps: {
    variant: "left-accent",
    colorScheme: "blue"
  }
});
export {
  S as default
};
